/* 0.47.47 - The order of an Information card's parts.
 *
 * The card's parts, top to bottom, as the Henaket spec draws them:
 * status badge, icon, icon description, title, main description, the
 * divider (a line, or the divider image) and each section. The Edit
 * button stays at the top right and the action button at the foot.
 *
 * e.part_order lists the parts in the admin's order. Unset is the
 * Henaket order and the card is drawn exactly as before. A part the
 * list leaves out (a section added later) takes its Henaket place
 * after the parts before it. */

export const INFO_PART_FIXED = ['badge', 'icon', 'icon_text', 'title', 'id_text', 'divider'];
export const INFO_HEADER_PARTS = new Set(['badge', 'icon', 'icon_text', 'title', 'id_text']);

export function infoSectionCount(e) {
  const c = parseInt(e && e.section_count, 10);
  return Number.isFinite(c) ? Math.min(Math.max(c, 1), 15) : 8;
}

export function infoDefaultOrder(e) {
  const out = [...INFO_PART_FIXED];
  for (let n = 1; n <= infoSectionCount(e); n++) out.push(`section_${n}`);
  return out;
}

/* The order to draw, or null for the Henaket order. */
export function infoCardOrder(e) {
  const saved = e && Array.isArray(e.part_order) ? e.part_order.map(String) : null;
  if (!saved || saved.length === 0) return null;
  const def = infoDefaultOrder(e);
  const known = new Set(def);
  const order = saved.filter((p, i) => known.has(p) && saved.indexOf(p) === i);
  // Missing parts go in after the part that precedes them in the
  // Henaket order (or first).
  def.forEach((p, i) => {
    if (order.includes(p)) return;
    const prev = def.slice(0, i).reverse().find(q => order.includes(q));
    order.splice(prev ? order.indexOf(prev) + 1 : 0, 0, p);
  });
  return order.join('|') === def.join('|') ? null : order;
}

export function infoPartLabel(p, e) {
  const m = /^section_(\d+)$/.exec(p);
  if (m) {
    const lab = e && e[`section_${m[1]}_label`];
    return `Section ${m[1]}${lab ? `: ${String(lab).slice(0, 30)}` : ''}`;
  }
  return {
    badge: 'Status badge', icon: 'Icon', icon_text: 'Icon description', title: 'Title',
    id_text: 'Main description', divider: 'Divider (line or image)',
  }[p] || p;
}
